// extracted by mini-css-extract-plugin
export default {"root":"mixing-summary-and-calculate-card_root__eDmDU","label":"mixing-summary-and-calculate-card_label__dM40m"};